module.exports = __webpack_public_path__ + "static/media/panic.e6fc0d7a.png";